export var DateRangeAttributes = /*#__PURE__*/ function(DateRangeAttributes) {
    DateRangeAttributes["XAdCreativeSignaling"] = "X-AD-CREATIVE-SIGNALING";
    DateRangeAttributes["Duration"] = "DURATION";
    DateRangeAttributes["Class"] = "CLASS";
    DateRangeAttributes["PlannedDuration"] = "PLANNED-DURATION";
    DateRangeAttributes["StartDate"] = "START-DATE";
    DateRangeAttributes["Scte35Cmd"] = "SCTE35-CMD";
    DateRangeAttributes["Scte35In"] = "SCTE35-IN";
    DateRangeAttributes["Scte35Out"] = "SCTE35-OUT";
    DateRangeAttributes["EndDate"] = "END-DATE";
    DateRangeAttributes["Id"] = "ID";
    return DateRangeAttributes;
}({});
/**
 * @public
 */ export var InterpolationStrategies = /*#__PURE__*/ function(InterpolationStrategies) {
    InterpolationStrategies["JustThrottle"] = "JustThrottle";
    InterpolationStrategies["FullInterpolation"] = "FullInterpolation";
    InterpolationStrategies["None"] = "None";
    return InterpolationStrategies;
}({});
export var PlaybackTypeKey = /*#__PURE__*/ function(PlaybackTypeKey) {
    PlaybackTypeKey["LINEAR"] = "linear";
    PlaybackTypeKey["VOD"] = "vod";
    return PlaybackTypeKey;
}({});
// Stage 3 Proposal
// https://github.com/tc39/proposal-promise-allSettled
export var PromiseStatus = /*#__PURE__*/ function(PromiseStatus) {
    PromiseStatus["Fulfilled"] = "Fulfilled";
    PromiseStatus["Rejected"] = "Rejected";
    return PromiseStatus;
}({});

//# sourceMappingURL=utils.enums.js.map